<div class="declarer-evenement">
	@if (loadingFormulaire()) {
		<div class="spinner">
			<div class="app-spinner"></div>
		</div>
	} @else {
		<form [formGroup]="formDeclarerEvenement" class="forumlaire-declarer-evenement">
			<div class="message-information">
				<p-message severity="warn" text="{{ 'ACCUEIL.DECLARATION_EVENEMENT.MESSAGE_PREVENTION_FORMULAIRE' | translate }}"></p-message>
			</div>
			<div class="selection-radio">
				<label for="duree">{{ 'ACCUEIL.DECLARATION_EVENEMENT.LABEL_DUREE' | translate }} :</label>
				<div *ngFor="let duree of durees" class="checkbox-selection-radio" id="duree">
					<p-radioButton
							[inputId]="duree.code"
							[value]="duree"
							formControlName="duree"/>
					<label [for]="duree.code" class="ml-2">
						{{ duree.designation }}
					</label>
				</div>
			</div>
			<div class="selection-radio">
				<label for="duree">{{ 'ACCUEIL.DECLARATION_EVENEMENT.LABEL_TYPE' | translate }} :</label>
				<div *ngFor="let type of types" class="checkbox-selection-radio" id="type">
					<p-radioButton
							[inputId]="type.code"
							[value]="type"
							(onClick)="onClickType(type)"
							formControlName="type"/>
					<label [for]="type.code" class="ml-2">
						{{ type.designation }}
					</label>
				</div>
			</div>
			<div class="saisi-commentaire">
				<label [ngClass]="modeReservationActive() ? 'mode-reservation' : ''"
					   for="commentaire">{{ 'ACCUEIL.DECLARATION_EVENEMENT.LABEL_COMMENTAIRE' | translate }} {{ formDeclarerEvenement.get('commentaire').value.length }} / 255 :</label>
				<textarea
						rows="4"
						cols="30"
						id="commentaire"
						pInputTextarea
						formControlName="commentaire">
			</textarea>
			</div>
			<div class="validation-formulaire">
				@if (estLimiteCaractereCommentaireDepassee()) {
					<p class="message-form-erreur">{{ 'ACCUEIL.DECLARATION_EVENEMENT.ERREUR.NOMBRE_CARACTERE_MAX_COMMENTAIRE_ATTEINT' | translate }}</p>
				}
				@if (afficherMessageErreurForm) {
					<p class="message-form-erreur">{{ messageErreurForm() }}</p>
				}
				<div class="bouton-action">
					<p-button
							(click)="declarerEvenementOuReservation()"
							[loading]="loadingDeclarationEvenement()"
							type="submit"
							[disabled]="estBoutonReservationDisabled()"
							label="{{ determinerLabelBoutonValidation() }}"/>
					@if (modeReservationActive()) {
						<i class="pi pi-info-circle information-reservation"
						   pTooltip="{{ 'ACCUEIL.MESSAGE_INFORMATION_RESERVATION' | translate }}"></i>
					}
				</div>
			</div>
		</form>
		@if (durees.length > 0) {
			<app-recapitulatif-declarer-evenement-modal
					[visible]="showConfirmationDemandeModal()"
					[plagesSelectionnees]="plagesSelectionnees()"
					[type]="formDeclarerEvenement.get('type').value"
					[duree]="formDeclarerEvenement.get('duree').value"
					[commentaire]="formDeclarerEvenement.get('commentaire').value"
					[loginUtilisateur]="loginUtilisateur"
					[langueUtilisateur]="langueUtilisateur"
					[durees]="durees"
					(visibleChange)="showConfirmationDemandeModal.set($event)"
					(notifierCreationEvenementEffective)="onNotifierCreationEvenementsEffective()"/>
		}
	}
</div>
